/* kt.js - Verhalten der Kerntemperatur-Seite.
   Vanilla, kein Framework, kein Build.

   Grundsatz: Dieses Skript rechnet nichts aus, was nicht in kt-daten.liquid
   steht. Es waehlt aus und stellt dar. Preise kommen aus serverseitig
   gerenderten Kacheln, die hier nur umgehaengt werden. */
(function () {
  'use strict';

  var SPEICHER = 'kt-auswahl';

  function sanft() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function grad(bereich) {
    // "54-57" wird zu "54–57 °C", "65-65" zu "65 °C"
    var t = bereich.split('-');
    if (t.length === 1 || t[0] === t[1]) return t[0] + ' °C';
    return t[0] + '–' + t[1] + ' °C';
  }

  function mitte(bereich) {
    var t = bereich.split('-');
    var a = parseInt(t[0], 10);
    var b = parseInt(t[1] != null ? t[1] : t[0], 10);
    return Math.round((a + b) / 2);
  }

  function nachzugText(n) {
    if (n >= 5) return 'um 4 bis 6 °C';
    if (n <= 2) return 'um 1 bis 2 °C';
    return 'um 2 bis 3 °C';
  }

  function stufenVon(stueck) {
    // Reihenfolge wie in den Daten, nicht wie im String
    if (stueck.typ !== 'stufen' && stueck.typ !== 'einzel') return [];
    var vorhanden = {};
    stueck.temps.split(';').forEach(function (p) {
      var t = p.split(':');
      vorhanden[t[0]] = t[1];
    });
    return window.KT_STUFEN.filter(function (s) { return vorhanden[s.k]; })
      .map(function (s) { return { k: s.k, n: s.n, de: s.de, c: s.c, t: vorhanden[s.k] }; });
  }

  function escape(s) {
    return String(s).replace(/[&<>"']/g, function (z) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[z];
    });
  }

  function melden(text) {
    var alt = document.querySelector('[data-kt-toast]');
    if (alt) alt.remove();
    var box = document.createElement('div');
    box.className = 'kt kt-toast';
    box.setAttribute('role', 'status');
    box.setAttribute('data-kt-toast', '');
    box.textContent = text;
    document.body.appendChild(box);
    requestAnimationFrame(function () { box.classList.add('is-visible'); });
    setTimeout(function () {
      box.classList.remove('is-visible');
      setTimeout(function () { box.remove(); }, 400);
    }, 5000);
  }

  function initRechner(wurzel) {
    var rohdaten = wurzel.querySelector('[data-kt-daten]');
    if (!rohdaten) return;

    var daten;
    try {
      daten = JSON.parse(rohdaten.textContent);
    } catch (e) {
      // Lieber gar kein Rechner als ein kaputter. Die Tabelle bleibt erreichbar.
      return;
    }
    window.KT_STUFEN = daten.stufen;

    var nachId = {};
    daten.stuecke.forEach(function (c) { nachId[c.id] = c; });

    var tierKnoepfe = Array.prototype.slice.call(wurzel.querySelectorAll('[data-kt-tier]'));
    var cutKnoepfe = Array.prototype.slice.call(wurzel.querySelectorAll('[data-kt-cut]'));
    var cutHinweis = wurzel.querySelector('[data-kt-cuthint]');
    var stufeHost = wurzel.querySelector('[data-kt-stufe-host]');
    var leer = wurzel.querySelector('[data-kt-leer]');
    var voll = wurzel.querySelector('[data-kt-voll]');
    var produktLager = wurzel.querySelector('[data-kt-produkte]');

    var wahl = { tier: null, cut: null, stufe: null };

    /* ---- Zustand sichern und aus der Adresszeile lesen ----------------- */
    function ausAdresse() {
      try {
        var q = new URLSearchParams(location.search);
        var id = q.get('stueck');
        if (id && nachId[id]) {
          var st = q.get('stufe');
          var moeglich = stufenVon(nachId[id]).map(function (s) { return s.k; });
          return { tier: nachId[id].tier, cut: id, stufe: moeglich.indexOf(st) > -1 ? st : null };
        }
        var ls = JSON.parse(localStorage.getItem(SPEICHER) || 'null');
        if (ls && ls.cut && nachId[ls.cut]) return ls;
      } catch (e) {}
      return null;
    }

    function sichern() {
      try { localStorage.setItem(SPEICHER, JSON.stringify(wahl)); } catch (e) {}
      if (!wahl.cut) return;
      try {
        var u = new URL(location.href);
        u.searchParams.set('stueck', wahl.cut);
        if (wahl.stufe) u.searchParams.set('stufe', wahl.stufe); else u.searchParams.delete('stufe');
        history.replaceState(null, '', u);
      } catch (e) {}
    }

    /* ---- Auswahl ------------------------------------------------------ */
    function tierSetzen(k, zuruecksetzen) {
      wahl.tier = k;
      tierKnoepfe.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.ktTier === k));
      });
      cutKnoepfe.forEach(function (b) {
        b.hidden = b.dataset.ktCutTier !== k;
      });
      if (cutHinweis) cutHinweis.hidden = true;
      if (zuruecksetzen) {
        wahl.cut = null;
        wahl.stufe = null;
        cutKnoepfe.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        zeichnen();
      }
    }

    function cutSetzen(id) {
      var c = nachId[id];
      if (!c) return;
      if (wahl.tier !== c.tier) tierSetzen(c.tier, false);
      wahl.cut = id;
      var st = stufenVon(c);
      // Medium Rare ist der haeufigste Einstieg, sonst Medium, sonst die erste
      var keys = st.map(function (s) { return s.k; });
      wahl.stufe = keys.indexOf('mr') > -1 ? 'mr' : (keys.indexOf('m') > -1 ? 'm' : keys[0] || null);
      cutKnoepfe.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.ktCut === id));
      });
      zeichnen();
      sichern();
    }

    function stufeSetzen(k) {
      wahl.stufe = k;
      zeichnen();
      sichern();
    }

    /* ---- Garstufen-Schieber ------------------------------------------- */
    function schieberBauen(c) {
      var st = stufenVon(c);
      stufeHost.innerHTML = '';

      if (c.typ === 'sicher') {
        // Der volle BfR-Hinweis steht in der Ergebniskarte. Hier nur der Grund,
        // warum es keinen Schieber gibt, sonst steht derselbe Text zweimal.
        stufeHost.innerHTML = '<div class="kt-safety"><div><p><b>Keine Garstufe, ein Sicherheitswert.</b> ' +
          'Bei ' + escape(c.voll) + ' entscheidet nicht der Geschmack, sondern das Durchgaren. ' +
          'Den Wert und die Begründung stehen im Ergebnis.</p></div></div>';
        return;
      }
      if (c.typ === 'schmor') {
        stufeHost.innerHTML = '<div class="kt-safety"><div><p><b>Hier zählt die Zeit, nicht die Garstufe.</b> ' +
          'Fertig ist es, wenn eine Gabel ohne Widerstand hineingleitet.</p></div></div>';
        return;
      }
      if (st.length === 1) {
        stufeHost.innerHTML = '<div class="kt-safety"><div><p>Für ' + escape(c.voll) +
          ' gibt es nur eine sinnvolle Garstufe: <b>' + escape(st[0].n) + ', ' + escape(st[0].de) + '</b>.</p></div></div>';
        return;
      }

      var idx = Math.max(0, st.map(function (s) { return s.k; }).indexOf(wahl.stufe));
      var n = st.length;
      var pos = function (i) { return n === 1 ? 50 : (i / (n - 1)) * 100; };
      var verlauf = 'linear-gradient(90deg,' + st.map(function (s, i) {
        return s.c + ' ' + pos(i) + '%';
      }).join(',') + ')';

      var huelle = document.createElement('div');
      huelle.className = 'kt-slider';
      huelle.innerHTML =
        '<div class="kt-slider__rail">' +
          '<div class="kt-slider__track" style="background:' + verlauf + '"></div>' +
          '<div class="kt-slider__ticks">' + st.map(function (s, i) {
            return '<span class="kt-slider__tick" style="left:' + pos(i) + '%"></span>';
          }).join('') + '</div>' +
          '<input type="range" class="kt-range" min="0" max="' + (n - 1) + '" step="1" value="' + idx + '" ' +
            'aria-label="Garstufe" aria-valuetext="' + escape(st[idx].n + ', ' + grad(st[idx].t)) + '">' +
        '</div>' +
        '<div class="kt-slider__labels">' + st.map(function (s, i) {
          var extra = n > 1 && i === 0 ? ' is-first' : (n > 1 && i === n - 1 ? ' is-last' : '');
          return '<button type="button" tabindex="-1" class="kt-slider__lab' + extra + '" ' +
            'style="left:' + pos(i) + '%" data-i="' + i + '" aria-current="' + (i === idx) + '">' +
            '<span>' + escape(s.n) + '</span><small>' + escape(s.de) + '</small></button>';
        }).join('') + '</div>';

      stufeHost.appendChild(huelle);

      var regler = huelle.querySelector('.kt-range');
      regler.addEventListener('input', function () {
        stufeSetzen(st[+regler.value].k);
      });
      huelle.querySelectorAll('.kt-slider__lab').forEach(function (b) {
        b.addEventListener('click', function () { stufeSetzen(st[+b.dataset.i].k); });
      });
    }

    /* ---- Ergebniskarte ------------------------------------------------ */
    function ergebnisBauen(c) {
      var st = stufenVon(c);
      var aktiv = null;
      st.forEach(function (s) { if (s.k === wahl.stufe) aktiv = s; });
      if (!aktiv && st.length) aktiv = st[0];

      var teile = [];
      var eyebrow = c.voll + (aktiv ? ' · ' + aktiv.n
        : c.typ === 'sicher' ? ' · Sicherheitswert' : ' · Schmorstück');

      /* Kopf mit der grossen Zahl */
      var gross;
      if (c.typ === 'schmor' && c.temps.indexOf('kern:') === -1) {
        gross = '<p class="kt-temp kt-temp--zeit">' + escape(c.zeitkurz) + '</p>' +
          '<p class="kt-card__unter">Garzeit, ' + escape(c.zeit) + '</p>';
      } else if (c.typ === 'schmor') {
        var kern = c.temps.split('kern:')[1];
        gross = '<p class="kt-temp">' + mitte(kern) + '<sup>°C</sup></p>' +
          '<p class="kt-card__unter">Zielbereich <b>' + grad(kern) + '</b> im Kern</p>' +
          '<p class="kt-card__unter">' + escape(c.zeit) + '</p>';
      } else if (c.typ === 'sicher') {
        var mind = c.temps.replace('min:', '');
        gross = '<p class="kt-card__unter">mindestens</p>' +
          '<p class="kt-temp">' + mind + '<sup>°C</sup></p>' +
          '<p class="kt-card__unter">im Kern, zwei Minuten gehalten, an der dicksten Stelle gemessen</p>';
      } else {
        gross = '<p class="kt-temp">' + mitte(aktiv.t) + '<sup>°C</sup></p>' +
          '<p class="kt-card__unter">Zielbereich <b>' + grad(aktiv.t) + '</b></p>';
      }

      teile.push('<div class="kt-card__head">' +
        '<p class="kt-card__eyebrow">' +
          (aktiv ? '<span class="kt-dot" style="background:' + aktiv.c + '"></span>' : '') +
          escape(eyebrow) + '</p>' + gross + '</div>');

      /* Beschreibung */
      var beschreibung = aktiv ? daten.beschreibung[aktiv.k]
        : c.typ === 'sicher' ? 'Durchgegart, der Saft läuft klar, innen kein Rosa mehr.'
        : 'Zart, saftig und so weich, dass es fast von selbst zerfällt.';
      teile.push('<p class="kt-desc">' + escape(beschreibung) + '</p>');

      /* Runter vom Feuer, oder Sicherheitshinweis */
      var links;
      if (aktiv && c.typ !== 'sicher') {
        var ziel = mitte(aktiv.t);
        var runter = ziel - parseInt(c.nachzug, 10);
        links = '<div>' +
          '<p class="kt-label">Runter vom Feuer bei</p>' +
          '<div class="kt-pull">' +
            '<span class="kt-temp kt-temp--sm">' + runter + '<sup>°C</sup></span>' +
            '<span style="color:var(--kt-gold-t);line-height:0">' + pfeil() + '</span>' +
            '<span class="kt-pull__ziel"><b>' + ziel + ' °C</b><small>nach der Ruhezeit</small></span>' +
          '</div>' +
          '<p class="kt-pull__note">Das Stück zieht in der Ruhezeit ' + nachzugText(parseInt(c.nachzug, 10)) + ' nach.</p>' +
        '</div>';
      } else if (c.sicherheit && c.sicherheit !== '-') {
        links = '<div class="kt-safety kt-safety--warn"><div><p>' + escape(c.sicherheit) + '</p>' +
          '<span class="kt-quelle">Quelle: BfR</span></div></div>';
      } else {
        links = '<div class="kt-safety"><div><p><b>Hier zählt die Zeit, nicht die Garstufe.</b> ' +
          'Fertig ist es, wenn eine Gabel ohne Widerstand hineingleitet.</p></div></div>';
      }

      var ruheTeile = c.ruhelang.split(',');
      var rechts = '<div>' +
        '<p class="kt-label">Ruhezeit</p>' +
        '<div class="kt-rest">' + uhr() +
          '<span><b>' + escape(ruheTeile[0]) + '</b>' +
          (ruheTeile.length > 1 ? escape(',' + ruheTeile.slice(1).join(',')) : '') + '</span>' +
        '</div></div>';

      teile.push('<div class="kt-duo">' + links + rechts + '</div>');

      /* Zubereitung */
      teile.push('<div><p class="kt-label">Passt zu</p><div class="kt-pills">' +
        c.methoden.split('~').map(function (m) {
          return '<span class="kt-pill">' + escape(m) + '</span>';
        }).join('') + '</div></div>');

      /* Sicherheitshinweis zusaetzlich, wenn er nicht schon links steht */
      if (c.sicherheit && c.sicherheit !== '-' && aktiv) {
        teile.push('<div class="kt-safety kt-safety--warn"><div><p>' + escape(c.sicherheit) +
          '</p><span class="kt-quelle">Quelle: BfR</span></div></div>');
      }

      teile.push('<div class="kt-prod" data-kt-produktslot></div>');
      teile.push('<button type="button" class="kt-prod__mehr" data-kt-teilen style="color:var(--kt-gold-t)">' +
        kette() + 'Link zu diesem Ergebnis kopieren</button>');

      voll.innerHTML = teile.join('');

      /* Produktkachel aus dem serverseitigen Lager einhaengen */
      var slot = voll.querySelector('[data-kt-produktslot]');
      var kachel = produktLager && produktLager.querySelector('[data-kt-produkt="' + c.id + '"]');
      if (slot && kachel) {
        slot.appendChild(kachel.cloneNode(true));
      } else if (slot) {
        slot.remove();
      }

      var teilen = voll.querySelector('[data-kt-teilen]');
      if (teilen) {
        teilen.addEventListener('click', function () {
          var u = new URL(location.href);
          u.searchParams.set('stueck', c.id);
          if (wahl.stufe) u.searchParams.set('stufe', wahl.stufe);
          if (navigator.clipboard) {
            navigator.clipboard.writeText(u.toString()).then(function () {
              melden('Link kopiert.');
            }).catch(function () {
              melden('Kopieren hat nicht geklappt. Du kannst den Link aus der Adresszeile nehmen.');
            });
          } else {
            melden('Kopieren hat nicht geklappt. Du kannst den Link aus der Adresszeile nehmen.');
          }
        });
      }
    }

    function pfeil() {
      return '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" ' +
        'stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    }
    function uhr() {
      return '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" ' +
        'stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M10 2h4M12 14l3-3M12 22a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"/></svg>';
    }
    function kette() {
      return '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" ' +
        'stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>';
    }

    function zeichnen() {
      var c = wahl.cut ? nachId[wahl.cut] : null;
      if (!c) {
        leer.hidden = false;
        voll.hidden = true;
        stufeHost.innerHTML = '<p class="kt-cut__hint">Erscheint, sobald du ein Stück gewählt hast.</p>';
        return;
      }
      leer.hidden = true;
      voll.hidden = false;
      schieberBauen(c);
      ergebnisBauen(c);
    }

    /* ---- Ereignisse --------------------------------------------------- */
    tierKnoepfe.forEach(function (b) {
      b.addEventListener('click', function () { tierSetzen(b.dataset.ktTier, true); });
    });
    cutKnoepfe.forEach(function (b) {
      b.addEventListener('click', function () { cutSetzen(b.dataset.ktCut); });
    });
    wurzel.querySelectorAll('[data-kt-schnell]').forEach(function (b) {
      b.addEventListener('click', function () { cutSetzen(b.dataset.ktSchnell); });
    });

    /* ---- Suche -------------------------------------------------------- */
    var feld = wurzel.querySelector('[data-kt-suche]');
    var liste = wurzel.querySelector('[data-kt-sugg]');
    if (feld && liste) {
      var hoch = 0;
      var treffer = [];

      var norm = function (s) {
        return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
      };

      var zeichnenListe = function () {
        if (!treffer.length) {
          liste.innerHTML = '<li class="kt-sugg__leer">Kein Stück gefunden. Versuch es mit einem anderen Namen.</li>';
          return;
        }
        liste.innerHTML = treffer.map(function (r, i) {
          var tier = daten.stuecke.filter(function (x) { return x.id === r.c.id; })[0].tier;
          var tierName = (window.KT_TIERNAMEN && window.KT_TIERNAMEN[tier]) || tier;
          return '<li role="option" aria-selected="' + (i === hoch) + '">' +
            '<button type="button" class="' + (i === hoch ? 'is-hi' : '') + '" data-id="' + r.c.id + '">' +
            '<span>' + escape(r.c.voll) +
            (r.hit !== r.c.voll && r.hit !== r.c.name ? '<small style="margin-left:8px">„' + escape(r.hit) + '“</small>' : '') +
            '</span><small>' + escape(tierName) + '</small></button></li>';
        }).join('');
        liste.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('mousedown', function (e) { e.preventDefault(); });
          b.addEventListener('click', function () {
            cutSetzen(b.dataset.id);
            feld.value = '';
            schliessen();
          });
        });
      };

      var oeffnen = function () {
        liste.hidden = false;
        feld.setAttribute('aria-expanded', 'true');
      };
      var schliessen = function () {
        liste.hidden = true;
        feld.setAttribute('aria-expanded', 'false');
      };

      feld.addEventListener('input', function () {
        var q = norm(feld.value.trim());
        hoch = 0;
        if (q.length < 2) { schliessen(); return; }
        treffer = [];
        daten.stuecke.forEach(function (c) {
          var kandidaten = [c.voll, c.name].concat(c.syn.split('~'));
          for (var i = 0; i < kandidaten.length; i++) {
            if (norm(kandidaten[i]).indexOf(q) > -1) {
              treffer.push({ c: c, hit: kandidaten[i] });
              return;
            }
          }
        });
        treffer = treffer.slice(0, 7);
        zeichnenListe();
        oeffnen();
      });

      feld.addEventListener('keydown', function (e) {
        if (liste.hidden) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); hoch = Math.min(treffer.length - 1, hoch + 1); zeichnenListe(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); hoch = Math.max(0, hoch - 1); zeichnenListe(); }
        else if (e.key === 'Enter' && treffer[hoch]) { e.preventDefault(); cutSetzen(treffer[hoch].c.id); feld.value = ''; schliessen(); }
        else if (e.key === 'Escape') { schliessen(); }
      });
      feld.addEventListener('blur', function () { setTimeout(schliessen, 150); });
    }

    /* ---- Startzustand ------------------------------------------------- */
    window.KT_TIERNAMEN = {};
    tierKnoepfe.forEach(function (b) {
      window.KT_TIERNAMEN[b.dataset.ktTier] = b.textContent.trim();
    });

    var start = ausAdresse();
    var startTier = null;
    tierKnoepfe.forEach(function (b) {
      if (b.getAttribute('aria-pressed') === 'true') startTier = b.dataset.ktTier;
    });
    tierSetzen(start ? start.tier : (startTier || tierKnoepfe[0].dataset.ktTier), false);
    if (start && start.cut) {
      cutSetzen(start.cut);
      if (start.stufe) stufeSetzen(start.stufe);
      // Kommt jemand ueber einen geteilten Link, soll er das Ergebnis sehen
      if (location.search.indexOf('stueck=') > -1) {
        var ziel = wurzel.querySelector('[data-kt-ergebnis]');
        if (ziel) setTimeout(function () {
          ziel.scrollIntoView({ behavior: sanft() ? 'auto' : 'smooth', block: 'center' });
        }, 300);
      }
    } else {
      zeichnen();
    }
  }

  /* ---- Drucken --------------------------------------------------------- */
  function initDrucken() {
    document.querySelectorAll('[data-kt-drucken]').forEach(function (b) {
      if (b.dataset.ktBereit) return;
      b.dataset.ktBereit = '1';
      b.addEventListener('click', function () {
        // Gedruckt wird die eigene Druckseite, nicht das Bildschirmlayout.
        // Wer ein PDF will, waehlt im Dialog "Als PDF sichern".
        window.print();
      });
    });

    var blatt = document.querySelector('.kt-druck');
    if (!blatt || blatt.dataset.ktBereit) return;
    blatt.dataset.ktBereit = '1';

    // Der Block steckt tief in einer Section. Zum Drucken muss er direkt unter
    // body haengen, sonst laesst sich der Rest der Seite nicht sauber
    // ausblenden und der Ausdruck wird seitenlang.
    var platzhalter = document.createComment('kt-druck');
    var versteckt = [];
    function raus() {
      if (blatt.parentNode && blatt.parentNode !== document.body) {
        blatt.parentNode.insertBefore(platzhalter, blatt);
        document.body.appendChild(blatt);
      }
      document.documentElement.classList.add('kt-drucken');
      // Cookie-Banner und aehnliche Einblendungen liegen oft in einem Shadow
      // Root. Von aussen laesst sich nur das Wirtselement ansprechen, und das
      // haengt nicht immer direkt unter body. Deshalb hier direkt am Element.
      versteckt = [];
      document.querySelectorAll('body > *').forEach(function (el) {
        if (el === blatt || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return;
        versteckt.push([el, el.style.display]);
        el.style.display = 'none';
      });
    }
    function zurueck() {
      document.documentElement.classList.remove('kt-drucken');
      versteckt.forEach(function (paar) { paar[0].style.display = paar[1]; });
      versteckt = [];
      if (platzhalter.parentNode) platzhalter.parentNode.replaceChild(blatt, platzhalter);
    }
    window.addEventListener('beforeprint', raus);
    window.addEventListener('afterprint', zurueck);
    // Safari kennt die Ereignisse nicht zuverlaessig, deshalb zusaetzlich ueber
    // die Medienabfrage
    if (window.matchMedia) {
      var mq = window.matchMedia('print');
      var hoeren = function (e) { if (e.matches) raus(); else zurueck(); };
      if (mq.addEventListener) mq.addEventListener('change', hoeren);
      else if (mq.addListener) mq.addListener(hoeren);
    }
  }

  /* ---- Seitenlink kopieren --------------------------------------------- */
  function initKopieren() {
    document.querySelectorAll('[data-kt-kopieren]').forEach(function (b) {
      b.addEventListener('click', function () {
        var text = b.dataset.ktKopieren || location.href.split('?')[0];
        if (!navigator.clipboard) {
          melden('Kopieren hat nicht geklappt. Du kannst den Link aus der Adresszeile nehmen.');
          return;
        }
        navigator.clipboard.writeText(text).then(function () {
          b.classList.add('is-done');
          melden('Link kopiert.');
          setTimeout(function () { b.classList.remove('is-done'); }, 2500);
        }).catch(function () {
          melden('Kopieren hat nicht geklappt. Du kannst den Link aus der Adresszeile nehmen.');
        });
      });
    });
  }

  /* ---- Lesezeit-Leiste ------------------------------------------------- */
  function initLeseleiste() {
    var leiste = document.querySelector('[data-kt-leseleiste]');
    if (!leiste || leiste.dataset.ktBereit) return;
    leiste.dataset.ktBereit = '1';

    // Der Inhalt sind alle Abschnitte dieser Seite, nicht der alte Beitragstext
    var teile = Array.prototype.slice.call(document.querySelectorAll('.kt-section'))
      .filter(function (e) { return !e.contains(leiste); });
    if (!teile.length) return;

    var anzeige = leiste.querySelector('[data-kt-lesezeit]');
    if (anzeige) {
      // Nur Fliesstext zaehlen. Tabellenzahlen, Chips und Rechner liest
      // niemand von oben nach unten durch, sie wuerden die Zeit verdreifachen.
      var woerter = 0;
      teile.forEach(function (abschnitt) {
        abschnitt.querySelectorAll('h1, h2, h3, p, li').forEach(function (e) {
          if (e.closest('.kt-table, .kt-mcards, .kt-calc, .kt-jumps, .kt-pills, .kt-toc')) return;
          var t = e.textContent.trim();
          if (t) woerter += t.split(/\s+/).length;
        });
      });
      if (!woerter) woerter = 1;
      var minuten = Math.max(1, Math.round(woerter / 240));
      var vorlage = leiste.dataset.ktLesezeitText || '[x] Minuten Lesezeit';
      var fertig = vorlage.indexOf('[x]') > -1 ? vorlage.replace('[x]', minuten)
        : minuten + ' Minuten Lesezeit';
      anzeige.textContent = fertig;
      anzeige.dataset.ktStandard = fertig;
    }

    // Beim Zeigen auf die Pfeile steht dort der Titel des Nachbarbeitrags
    leiste.querySelectorAll('.kt-leseleiste__link[data-titel]').forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        if (anzeige) anzeige.textContent = a.dataset.titel;
      });
      a.addEventListener('mouseleave', function () {
        if (anzeige) anzeige.textContent = anzeige.dataset.ktStandard || '';
      });
    });

    var laeuft = false;
    function messen() {
      laeuft = false;
      var oben = teile[0].getBoundingClientRect().top + window.scrollY;
      var unten = teile[teile.length - 1].getBoundingClientRect().bottom + window.scrollY;
      var strecke = unten - oben - window.innerHeight + 200;
      var anteil = strecke > 0 ? Math.min(100, Math.max(0, ((window.scrollY - oben) / strecke) * 100)) : 0;
      leiste.style.setProperty('--pagination-percent', Math.round(anteil) + '%');
      // Erst einblenden, wenn der Besucher wirklich im Inhalt ist
      leiste.classList.toggle('is-visible', window.scrollY > oben + 120 && window.scrollY < unten + 300);
    }
    function aufScroll() {
      if (laeuft) return;
      laeuft = true;
      requestAnimationFrame(messen);
    }
    window.addEventListener('scroll', aufScroll, { passive: true });
    window.addEventListener('resize', aufScroll, { passive: true });
    messen();
  }

  function start() {
    document.querySelectorAll('[data-kt-rechner]').forEach(initRechner);
    initDrucken();
    initKopieren();
    initLeseleiste();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Im Theme-Editor werden Sections einzeln neu geladen
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-kt-rechner]').forEach(initRechner);
    initDrucken();
    initKopieren();
    initLeseleiste();
  });
})();
